module.exports = __webpack_public_path__ + "img/leftCenter.ebc193d5.png";